import React from 'react';

interface CommunityContext {
  communities?: {id: string; name?: string}[];
}

const defaultState = {
  communities: [],
};

export const communityContext =
  React.createContext<CommunityContext>(defaultState);

type CommunityProviderProps = {
  children: React.ReactNode;
} & CommunityContext;

export const CommunityProvider = ({
  children,
  communities,
}: CommunityProviderProps) => {
  return (
    <communityContext.Provider
      value={{
        communities,
      }}>
      {children}
    </communityContext.Provider>
  );
};
